import type { ChannelMessage } from "../_api/channel-endpoints";
import { isOptimisticMessage } from "./optimistic-message";

/**
 * The newest persisted message in the loaded window, or `null` when nothing is loaded.
 *
 * `useChannelMessages` returns oldest-first, so the newest is the tail. Optimistic
 * placeholders carry an `optimistic:` id and are skipped — a not-yet-persisted message is not
 * a real position in the thread, so it must never become the read cursor nor move the
 * "is this prompt still the last message" reference.
 */
export function getNewestMessageId(messages: ChannelMessage[]): string | null {
  return (
    messages.filter((message) => !isOptimisticMessage(message)).at(-1)?.id ??
    null
  );
}
